import moment from 'moment-timezone';

moment.tz.setDefault('Europe/Zurich');

export default moment;
